import React from 'react'


export default function StickyBar({ children }: any) {
    return <div className="sticky bottom-0">{children}</div>
}
